module.exports = __webpack_public_path__ + "img/sars_cov_ies_de.3831f12e.jpg";